/**
 * Test IDs for QA automation.
 */
export const testIds = {
  driverDocumentsTableOpenDocument: "driver-documents-table-open-document",
} as const;
